export const AppointmentLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
    Subject: 1000,
}

export const AppointmentEmployeeLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const AssetTransferLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const AttachmentLengths = {
    AttachmentName: 400,
    ContentType: 250,
    CreatedBy: 250,
    Description: 400,
    FileName: 4000,
    ModifiedBy: 250,
}

export const AuditLogLengths = {
    Description: 4000,
    Source: 250,
    TypeName: 250,
    UserName: 250,
}

export const AuditLogDetailLengths = {
    PropertyName: 250,
}

export const AuthClientLengths = {
    Brand: 250,
    CreatedBy: 250,
    DeviceName: 250,
    DeviceType: 250,
    IPAddress: 100,
    Model: 250,
    ModifiedBy: 250,
    OSVersion: 250,
    Token: 250,
    UserAgent: 250,
    Version: 250,
}

export const AuthPermissionLengths = {
    CreatedBy: 250,
    Description: 1000,
    ModifiedBy: 250,
    Name: 250,
    Section: 250,
    SimpleDescription: 1000,
}

export const AuthRoleLengths = {
    CreatedBy: 250,
    Description: 1000,
    ModifiedBy: 250,
    Name: 250,
}

export const AuthRolePermissionLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const AuthUserLengths = {
    CreatedBy: 250,
    LegacyUserName: 250,
    ModifiedBy: 250,
    Password: 400,
    UserName: 250,
}

export const AuthUserColumnMappingLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const AuthUserConfigurationLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const AuthUserKnowledgeLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
    Response: 400,
}

export const AuthUserPermissionLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const AuthUserRoleLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const AuthUserWidgetLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const BaseModelConfigurationLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const BundleLengths = {
    CreatedBy: 250,
    Description: 4000,
    ModifiedBy: 250,
    Name: 250,
}

export const BundleInventoryLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const CampaignLengths = {
    CreatedBy: 250,
    Description: 4000,
    ModifiedBy: 250,
    Name: 400,
}

export const ClassificationLengths = {
    CreatedBy: 250,
    Description: 400,
    ModifiedBy: 250,
}

export const ClientQueueLengths = {
    CreatedBy: 250,
    Function: 400,
    Message: 400,
    ModifiedBy: 250,
}

export const CollectionLengths = {
    CollectionAddress: 500,
    CollectionDateStamp: 250,
    CollectionNumber: 250,
    CollectionTimeStamp: 250,
    CreatedBy: 250,
    ModifiedBy: 250,
    Reference: 250,
}

export const CollectionAreaLengths = {
    CreatedBy: 250,
    Description: 400,
    ModifiedBy: 250,
}

export const CollectionDocumentLengths = {
    ContentType: 80,
    CreatedBy: 250,
    Description: 80,
    FileName: 250,
    ModifiedBy: 250,
}

export const ColumnMappingLengths = {
    ColumnName: 100,
    CreatedBy: 250,
    Label: 250,
    Model: 100,
    ModifiedBy: 250,
}

export const CommentLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const CountryLengths = {
    Code: 250,
    CreatedBy: 250,
    Description: 400,
    ModifiedBy: 250,
}

export const CurrencyLengths = {
    Alpha2Code: 2,
    Code: 3,
    CreatedBy: 250,
    ModifiedBy: 250,
    Name: 250,
}

export const CustomerLengths = {
    CompanyNumber: 250,
    CreatedBy: 250,
    CustomerCode: 250,
    CustomerName: 250,
    CustomerZonePassword: 250,
    CustomField1: 400,
    CustomField2: 400,
    CustomField3: 400,
    CustomField4: 400,
    ModifiedBy: 250,
    VATNumber: 250,
}

export const CustomerContactLengths = {
    CreatedBy: 250,
    EmailAddress: 250,
    FaxNumber: 250,
    FirstName: 250,
    HomeNumber: 250,
    IDNumber: 250,
    LastName: 250,
    MobileNumber: 250,
    ModifiedBy: 250,
    WorkNumber: 250,
}

export const CustomerGroupLengths = {
    CreatedBy: 250,
    Description: 400,
    ModifiedBy: 250,
}

export const CustomerGroupCustomerLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const CustomerStatusLengths = {
    CreatedBy: 250,
    Description: 400,
    ModifiedBy: 250,
}

export const CustomerTypeLengths = {
    CreatedBy: 250,
    Description: 400,
    ModifiedBy: 250,
}

export const CustomFieldLengths = {
    CreatedBy: 250,
    FieldExternalID: 250,
    FieldLabel: 250,
    FieldType: 250,
    ModifiedBy: 250,
}

export const CustomFieldOptionLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const CustomFieldValueLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const DeliveryNoteLengths = {
    AdditionalNotes: 4000,
    CreatedBy: 250,
    DeliveredByContactNumber: 250,
    DeliveredByEmailAddress: 250,
    DeliveredByName: 250,
    ModifiedBy: 250,
    RecipientContactNumber: 250,
    RecipientEmailAddress: 250,
    RecipientName: 250,
}

export const DeliveryNoteItemLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
    Reason: 2000,
}

export const DesignationLengths = {
    CreatedBy: 250,
    Description: 400,
    ModifiedBy: 250,
}

export const DocumentDefinitionLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const EmployeeLengths = {
    CreatedBy: 250,
    DisplayColor: 250,
    EmailAddress: 250,
    EmployeeNumber: 250,
    FirstName: 250,
    LastName: 250,
    MobileNumber: 250,
    ModifiedBy: 250,
    PrimaryRole: 250,
}

export const EmployeeCustomerLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const EmployeeGroupLengths = {
    CreatedBy: 250,
    Description: 250,
    ModifiedBy: 250,
    Name: 250,
}

export const EmployeeGroupEmployeeLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const EmployeeJobCardStatusLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const EmployeeReportLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const EmployeeStoreLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const FaultCauseLengths = {
    Code: 250,
    CreatedBy: 250,
    Description: 400,
    ModifiedBy: 250,
}

export const FaultCodeLengths = {
    Code: 250,
    CreatedBy: 250,
    Description: 400,
    ModifiedBy: 250,
}

export const FaultReasonLengths = {
    Code: 250,
    CreatedBy: 250,
    Description: 400,
    ModifiedBy: 250,
}

export const FeedbackLengths = {
    Comment: 1000,
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const FieldSettingLengths = {
    CreatedBy: 250,
    Description: 1000,
    DisplayName: 250,
    FieldSystemName: 250,
    ModifiedBy: 250,
}

export const FinancialCategoryLengths = {
    Name: 400,
}

export const FormDataOptionLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const FormDefinitionLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
    Name: 250,
}

export const FormDefinitionFieldLengths = {
    CreatedBy: 250,
    DataType: 250,
    Description: 4000,
    ModifiedBy: 250,
}

export const FormHeaderLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const FormItemLengths = {
    CreatedBy: 250,
    Description: 4000,
    ModifiedBy: 250,
}

export const GeolocationLengths = {
    CreatedBy: 250,
    GPSStatus: 250,
    ModifiedBy: 250,
}

export const ImportLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const IndustryTypeLengths = {
    CreatedBy: 250,
    Description: 400,
    ModifiedBy: 250,
}

export const IntegrationLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
    Password: 250,
    UserName: 250,
}

export const IntegrationInventoryLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const IntegrationLineLengths = {
    ExternalDocNumber: 250,
    ExternalID: 250,
    Message: 4000,
}

export const IntegrationSettingLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
    SettingName: 4000,
    SettingValue: 4000,
}

export const InventoryLengths = {
    BinLocation: 4000,
    Code: 250,
    CreatedBy: 250,
    Description: 400,
    Image: 250,
    ModifiedBy: 250,
}

export const InventoryCategoryLengths = {
    Code: 250,
    CreatedBy: 250,
    Description: 400,
    ModifiedBy: 250,
}

export const InventorySectionLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const InventorySubcategoryLengths = {
    Code: 250,
    CreatedBy: 250,
    Description: 400,
    ModifiedBy: 250,
}

export const InventorySubcategorySupplierLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const InvoiceLengths = {
    Address: 500,
    Comment: 4000,
    CreatedBy: 250,
    InvoiceNumber: 250,
    ModifiedBy: 250,
    PurchaseOrderNumber: 250,
    Reference: 250,
    RepeatRules: 400,
}

export const InvoiceItemLengths = {
    CreatedBy: 250,
    Description: 4000,
    ModifiedBy: 250,
}

export const JobCardLengths = {
    Accessories: 2000,
    Address: 500,
    CourierName: 250,
    CourierNumber: 250,
    CreatedBy: 250,
    CreditNoteNumber: 250,
    CustomField1: 1000,
    CustomField2: 1000,
    CustomField3: 1000,
    CustomField4: 1000,
    Description: 4000,
    InvoiceNumber: 250,
    JobCardNumber: 250,
    ModifiedBy: 250,
    POPDocument: 250,
    PreviousJobNumber: 250,
    PurchaseOrderNumber: 250,
    QuoteNumber: 250,
    ReferenceNumber: 250,
    SerialNumber: 250,
    SignatureName: 250,
    SignatureTechnicianName: 250,
    SupplierNumber: 250,
    WarrantyNumber: 250,
}

export const JobCardAssessmentLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const JobCardCustomFieldLengths = {
    CreatedBy: 250,
    FieldExternalID: 250,
    FieldLabel: 250,
    FieldType: 250,
    ModifiedBy: 250,
}

export const JobCardCustomFieldOptionLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const JobCardCustomFieldValueLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const JobCardEmployeeLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const JobCardFaultCauseLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const JobCardFaultCodeLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const JobCardFaultReasonLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const JobCardInventoryLengths = {
    CreatedBy: 250,
    Description: 2000,
    ModifiedBy: 250,
    SerialNumber: 400,
}

export const JobCardRemovalLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const JobCardSequenceLengths = {
    CreatedBy: 250,
    Description: 250,
    ModifiedBy: 250,
}

export const JobCardSequenceQueueLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const JobCardSequenceStepLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const JobCardStatusLengths = {
    AuthoriseEmail: 250,
    AuthoriseMobile: 250,
    CreatedBy: 250,
    Description: 250,
    DisplayColor: 250,
    ModifiedBy: 250,
}

export const JobCardStatusChangeLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const JobCardStatusConnectionLengths = {
    CreatedBy: 250,
    Description: 250,
    ModifiedBy: 250,
}

export const JobCardSupplierLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const JobCardTimeLengths = {
    CreatedBy: 250,
    Description: 4000,
    ModifiedBy: 250,
}

export const JobScheduleLengths = {
    CreatedBy: 250,
    Description: 1000,
    JobScheduleNumber: 250,
    ModifiedBy: 250,
}

export const JobScheduleEmployeeLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const JobScheduleItemLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const JobStatusOptionLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const JobTypeLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
    Name: 250,
}

export const JobTypeFormDefinitionLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const JobTypeTaskTemplateLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const KnowledgeLengths = {
    Answer1: 400,
    Answer2: 400,
    Answer3: 400,
    Content: 400,
    CreatedBy: 250,
    ModifiedBy: 250,
    Question1: 400,
    Question2: 400,
    Question3: 400,
    Title: 250,
}

export const LinkLengths = {
    CreatedBy: 250,
    Description: 400,
    Item1DocNum: 250,
    Item2DocNum: 250,
    ModifiedBy: 250,
}

export const LocationLengths = {
    AddressLine1: 250,
    AddressLine2: 250,
    AddressLine3: 250,
    AddressLine4: 250,
    AddressLine5: 250,
    CreatedBy: 250,
    Description: 250,
    ERF: 250,
    ModifiedBy: 250,
}

export const MediaTypeLengths = {
    CreatedBy: 250,
    Description: 400,
    ModifiedBy: 250,
}

export const MessageCreditLengths = {
    CreatedBy: 250,
    ManagerCreatedBy: 250,
    ManagerModifiedBy: 250,
    ModifiedBy: 250,
}

export const MessageQueueLengths = {
    AttachmentFilePath: 2000,
    CCAddress: 400,
    CreatedBy: 250,
    ErrorMessage: 500,
    EventStatus: 100,
    FromAddress: 400,
    FromName: 400,
    MobileNumber: 400,
    ModifiedBy: 250,
    ReceivedData: 500,
    Recipient: 400,
    Subject: 250,
    ToAddress: 400,
    ToName: 400,
}

export const MessageQueueBulkLengths = {
    CreatedBy: 250,
    MessageSubject: 250,
    ModifiedBy: 250,
    Name: 400,
}

export const MessageQueueBulkItemLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const MessageQueueReplyLengths = {
    Body: 10000,
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const MessageSequenceLengths = {
    CreatedBy: 250,
    Description: 250,
    ModifiedBy: 250,
    Name: 250,
}

export const MessageSequenceQueueLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const MessageSequenceStepLengths = {
    CreatedBy: 250,
    Description: 250,
    ModifiedBy: 250,
    SendPreference: 250,
}

export const OptionLengths = {
    CreatedBy: 250,
    Description: 400,
    GroupName: 250,
    ModifiedBy: 250,
    OptionName: 250,
    OptionValue: 4000,
    SystemType: 250,
    Unit: 250,
}

export const PaymentLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const PaymentMethodLengths = {
    CreatedBy: 250,
    Description: 400,
    ModifiedBy: 250,
}

export const PickingSlipLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
    PickingSlipNumber: 250,
}

export const PriceListLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
    Name: 250,
}

export const PriceListInventoryLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const PriceListSubscribedLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const ProductLengths = {
    CreatedBy: 250,
    CustomField1: 400,
    CustomField2: 400,
    CustomField3: 400,
    CustomField4: 400,
    InvoiceNumber: 250,
    ModifiedBy: 250,
    ProductNumber: 250,
    SerialNumber: 250,
}

export const ProductSequenceLengths = {
    CreatedBy: 250,
    Description: 250,
    ModifiedBy: 250,
}

export const ProductSequenceQueueLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const ProductSequenceStepLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const ProjectLengths = {
    CreatedBy: 250,
    Description: 4000,
    ModifiedBy: 250,
    ProjectNumber: 250,
}

export const PurchaseOrderLengths = {
    Address: 500,
    Comment: 2000,
    CreatedBy: 250,
    DeliveryAddress: 400,
    DeliveryInstructions: 4000,
    ModifiedBy: 250,
    PurchaseOrderNumber: 250,
    Reference: 250,
}

export const PurchaseOrderItemLengths = {
    CreatedBy: 250,
    Description: 2000,
    ModifiedBy: 250,
}

export const QueryLengths = {
    Address: 500,
    CreatedBy: 250,
    CustomField1: 400,
    CustomField2: 400,
    CustomField3: 400,
    CustomField4: 400,
    InvoiceNumber: 250,
    ModifiedBy: 250,
    QueryCode: 250,
    Reference: 250,
    SerialNumber: 250,
}

export const QueryReasonLengths = {
    CreatedBy: 250,
    Description: 400,
    ModifiedBy: 250,
}

export const QueryStatusLengths = {
    CreatedBy: 250,
    Description: 400,
    DisplayColor: 250,
    ModifiedBy: 250,
}

export const QueryStatusChangeLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const QueryTypeLengths = {
    CreatedBy: 250,
    Description: 400,
    DisplayColor: 250,
    ModifiedBy: 250,
}

export const QueryTypeEmployeeLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const QuoteLengths = {
    Address: 500,
    Comment: 4000,
    CreatedBy: 250,
    InvoiceNumber: 250,
    ModifiedBy: 250,
    PurchaseOrderNumber: 250,
    QuoteNumber: 250,
    Reference: 250,
}

export const QuoteDetailLengths = {
    CreatedBy: 250,
    Description: 4000,
    ModifiedBy: 250,
}

export const QuoteItemTemplateLengths = {
    CreatedBy: 250,
    Description: 1000,
    ModifiedBy: 250,
}

export const QuoteTemplateLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const RecordSequenceLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
    SequenceKey: 250,
}

export const ReportLengths = {
    CreatedBy: 250,
    FileName: 250,
    ModifiedBy: 250,
    ReportName: 250,
}

export const ReportConfigTemplateLengths = {
    CreatedBy: 250,
    DataType: 250,
    DefaultValue: 250,
    InputType: 250,
    ModifiedBy: 250,
    Name: 250,
}

export const ReportQueueLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const ReportScheduleLengths = {
    CreatedBy: 250,
    Cron: 250,
    ModifiedBy: 250,
}

export const ReportScheduleConfigLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const ReportScheduleEmployeeLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const ReportScheduleStoreLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const SaleLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
    SalesNumber: 250,
}

export const SalesSourceLengths = {
    CreatedBy: 250,
    Description: 400,
    ModifiedBy: 250,
}

export const SalesStatusLengths = {
    CreatedBy: 250,
    Description: 400,
    DisplayColor: 250,
    ModifiedBy: 250,
}

export const SalesTypeLengths = {
    CreatedBy: 250,
    Description: 400,
    ModifiedBy: 250,
}

export const SectionLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const ServiceProductLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const ServiceReminderLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const ServiceRuleLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const ServiceSequenceLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const SignatureLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
    SignedBy: 250,
    Terms: 4000,
    Title: 250,
}

export const SignatureTemplateLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
    Name: 250,
    Terms: 4000,
    UserInstruction: 4000,
}

export const StockLedgerLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const StocktakeLengths = {
    Description: 4000,
    Name: 100,
    Notes: 4000,
}

export const StocktakeItemLengths = {
    Notes: 4000,
}

export const StocktakeTemplateLengths = {
    Description: 4000,
    Name: 400,
}

export const StockTransactionLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const StockTransactionLineLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const StoreLengths = {
    AddressLine1: 250,
    AddressLine2: 250,
    AddressLine3: 250,
    AddressLine4: 250,
    BankAccountName: 250,
    BankAccountNumber: 250,
    BankBranchCode: 250,
    BankBranchName: 250,
    BankName: 250,
    Code: 250,
    CollectionNotify: 250,
    CompanyRegistrationNo: 250,
    CreatedBy: 250,
    CustomerNotify: 250,
    CustomField1: 250,
    CustomField2: 250,
    EmailAddress: 250,
    EmailFromAddress: 250,
    EmailFromName: 250,
    FaxNumber: 250,
    InventoryNotify: 250,
    InvoiceComment: 4000,
    InvoiceNotify: 250,
    JobCardNotify: 250,
    ModifiedBy: 250,
    Name: 250,
    PostalLine1: 250,
    PostalLine2: 250,
    PostalLine3: 250,
    PostalLine4: 250,
    PrefixCustomer: 10,
    PrefixInvoice: 10,
    PrefixJobCard: 10,
    PrefixProduct: 10,
    PrefixQuery: 10,
    PrefixQuote: 10,
    PrefixSale: 10,
    ProductNotify: 250,
    QueryNotify: 250,
    QuoteComment: 4000,
    QuoteNotify: 250,
    RegisteredName: 250,
    TelephoneNumber: 250,
    VATRegistrationNo: 250,
    WebsiteAddress: 250,
}

export const SupplierLengths = {
    Code: 250,
    CompanyNumber: 250,
    ContactNumber: 250,
    CreatedBy: 250,
    EmailAddress: 250,
    ModifiedBy: 250,
    Name: 400,
    VATNumber: 250,
}

export const SupplierContactLengths = {
    CreatedBy: 250,
    EmailAddress: 250,
    FaxNumber: 250,
    FirstName: 250,
    HomeNumber: 250,
    IDNumber: 250,
    LastName: 250,
    MobileNumber: 250,
    ModifiedBy: 250,
    WorkNumber: 250,
}

export const SupplierInvoiceLengths = {
    Address: 500,
    Comment: 2000,
    CreatedBy: 250,
    DeliveryAddress: 400,
    DeliveryInstructions: 4000,
    ModifiedBy: 250,
    Reference: 250,
    SupplierInvoiceNumber: 250,
}

export const SupplierInvoiceItemLengths = {
    CreatedBy: 250,
    Description: 2000,
    ModifiedBy: 250,
}

export const SupplierStoreLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const TaskItemLengths = {
    CreatedBy: 250,
    ItemDataType: 250,
    ModifiedBy: 250,
}

export const TaskItemEmployeeLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const TaskItemTemplateLengths = {
    CreatedBy: 250,
    DataOption: 1000,
    DataType: 250,
    ModifiedBy: 250,
}

export const TaskTemplateLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const TaxTypeLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const TemplateLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
    Name: 250,
    SMSBody: 1000,
    Subject: 250,
}

export const TenantLengths = {
    AddressLine1: 250,
    AddressLine2: 250,
    AddressLine3: 250,
    AddressLine4: 250,
    BankAccountName: 250,
    BankAccountNumber: 250,
    BankBranchCode: 250,
    BankBranchName: 250,
    BankName: 250,
    CompanyRegistrationNo: 250,
    CreatedBy: 250,
    EmailAddress: 250,
    EmailFromAddress: 250,
    EmailFromName: 250,
    FaxNumber: 250,
    InvoiceComment: 4000,
    ModifiedBy: 250,
    PostalLine1: 250,
    PostalLine2: 250,
    PostalLine3: 250,
    PostalLine4: 250,
    QuoteComment: 4000,
    RegisteredName: 250,
    TelephoneNumber: 250,
    VATRegistrationNo: 250,
    WebsiteAddress: 250,
}

export const TermLengths = {
    Condition: 400,
    CreatedBy: 250,
    ModifiedBy: 250,
    Number: 2,
}

export const TriggerLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const TriggerActionLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const TriggerConditionLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const TriggerLogLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const TriggerRuleLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
    Name: 400,
    Setting1DataOption: 1000,
    Setting1DataType: 250,
    Setting2DataOption: 1000,
    Setting2DataType: 250,
}

export const UnitOfMeasurementLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
    Name: 100,
}

export const WarehouseLengths = {
    Code: 250,
    CreatedBy: 250,
    ModifiedBy: 250,
    Name: 400,
}

export const WarehouseStockLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const WebFormLengths = {
    CreatedBy: 250,
    ModifiedBy: 250,
}

export const WorkflowLengths = {
    CreatedBy: 250,
    Description: 4000,
    ModifiedBy: 250,
    Name: 250,
}
